module.exports = __webpack_public_path__ + "img/btn-icon-1.a07ddfcb.png";